import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, ControlValueAccessor } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IScreens } from '../../Interfaces/IScreens';
import { IVisitsTypes } from '../../Interfaces/IVisitsTypes';
import { RolesService } from '../../services/roles-service';
import { VisitsTypesService } from '../../services/visitstypes-service';
import { IBuildings } from '../../Interfaces/IBuildings';
import { ICompanySuppliers } from '../../Interfaces/ICompanySuppliers';
import { IEmployeesInActiveDirectory } from '../../Interfaces/IEmployeesInActiveDirectory';
import { ActiveDirectoryService } from '../../services/activedirectory-services';
import { BuildingsService } from '../../services/buildings-services';
import { CompanySuppliersService } from '../../services/companysuppliers-service';
import { IIdentificationsTypes } from '../../Interfaces/IIdentificationsTypes';
import { IdentificationsTypesService } from '../../services/identificationstypes-service';
import { IVisitors } from '../../Interfaces/IVisitors';
import { UploadImageComponent } from '../upload-image/upload-image.component';
import { IVisits } from '../../Interfaces/IVisits';
import { UploadImagePhotoComponent } from '../upload-image-photo/upload-image-photo.component';
import { VisitsService } from '../../services/visits-service';
import { PropertiesService } from '../../services/properties-services';
import { IProperties } from '../../Interfaces/IProperties';
import { UploadFileService } from '../../services/upload-file.service';
import { ISuppliersIncomeTypes } from '../../Interfaces/ISuppliersIncomeTypes';
import { SuppliersIncomeTypesService } from '../../services/suppliersincometype-service';
import { IActivitiesTypes } from '../../Interfaces/IActivitiesTypes';
import { AreasService } from '../../services/areas-services';
import { IAreas } from '../../Interfaces/IAreas';
import { IActivities } from '../../Interfaces/IActivities';
import { IProjects } from '../../Interfaces/IProjects';
import { ActivitiesService } from '../../services/activities-services';
import { ProjectsService } from '../../services/projects-services';
import { IEquipmentTypes } from '../../Interfaces/IEquipmentTypes';
import { EquipmentTypesService } from '../../services/equipmenttypes-service';
import { VisitorsEquipmentsService } from '../../services/visitors-equipments-services';
import { IVisitorEquipment } from '../../Interfaces/IVisitorsEquipments';
import { IVisitorVehicle } from '../../Interfaces/IVisitorVehicle';
import { VisitorsVehiclesService } from '../../services/visitors-vehicles-services';
import { DocumentsTypesService } from '../../services/documentstypes-service';
import { IDocumentsTypes } from '../../Interfaces/IDocumentsTypes';
import { UploadDocumentComponent } from '../upload-document/upload-document.component';
import { IDocumentsSuppliersVisits } from '../../Interfaces/IDocumentsSuppliersVisits';
import { SubtypesVisitsService } from '../../services/subtypesvisits-service';
import { ISubtypesVisits } from '../../Interfaces/ISubtypesVisits';
import { ISites } from '../../Interfaces/ISites';
import { SitesService } from '../../services/sites-services';
declare var jQuery: any;

interface DocumentsLoaded {
	documentName: string;
	pkDocument: number;
	requieredForeignVisit: boolean;
	loaded: boolean;
}

interface AnswersMacAddress{
	pkanswer: number;
    answer: string;	
}

@Component({
	selector: 'app-new-visit',
	templateUrl: './new-visit.component.html',
	styleUrls: ['./new-visit.component.scss'],
})
export class NewVisitComponent implements OnInit {
	activeIndex: number = 0;
	applicationpath: string = '';
    bucketS3Property: string = '';
    clearVisitorFields: boolean = false;
	private contExtraInfo = 0;
	columns: Array<any> = [
		'pkvisitorbyvisit',
		'visitorname',
		'idnumber',
		'email',
		'phone',
		'position',
		'temporarybadge',
		'foreignvisit',
		'identificationtype',
		'strimageID',
		'strimagePhoto',
		'changestatuscolumn',
		'editcolumn',
	];
	columnsEquipments: Array<any> = [
		'visitor',
		'type_equipment',
		'brand',
		'model',
		'serial_number',
		'havemacaddress',
		'macaddressinformation',
		'changestatuscolumn',
		'editcolumn',
	];
	columnsEquipments2: Array<any> = [
		'visitor',
		'type_equipment',
		'brand',
		'model',
		'serial_number',
		'mac_address',
		'mac_address2',
		'changestatuscolumn',
		'editcolumn',
	];
	columnsVehicles: Array<any> = [
		'visitor',
		'brand',
		'model',
		'color',
		'license_plate',
		'changestatuscolumn',
		'editcolumn',
	];
	dataDocumentToSend: IDocumentsSuppliersVisits = {
		pk_document_supplier_visit: 0,
		document_supplier_visit: '',
		fk_visit: 0,
		fk_document_type: 0,
		name_inbucket: '',
		creation_date: new Date(),
		fk_employee_creator: 0,
		last_updated: new Date(),
		fk_employee_updater: 0,
		available: false,
		username: '',
		fk_site: 0,
		document_type: '',
	};

	
	
	dataNotJabilVisitor: Array<IVisitors> = [];
	dateFrom: string;
	dateTo: string;
	disable: boolean;
	DisableUploadDocumentDC3: boolean = false;
	DisableUploadDocumentSDSheet: boolean = false;
	displayedColumns: Array<string> = this.columns.map((c) => c.columnDef);
	displayedColumnsEquipments: Array<string> = this.columnsEquipments.map(
		(c) => c.columnDef,
	);
	displayedColumnsEquipments2: Array<string> = this.columnsEquipments2.map(
		(c) => c.columnDef,
	);
	displayedColumnsVehicles: Array<string> = this.columnsVehicles.map(
		(c) => c.columnDef,
	);
	display: boolean = false;
	display_foreign_visit: boolean;
    display_not_found_project: boolean = false;
	enableBtnAddVisitor: boolean = false;
	formGroup: FormGroup;
	//
	hideMacaddres: boolean = true;
	hideCbjustification: boolean = false;
	hideJustification: boolean = true;
	AnswersMacAddress = [
		{pkanswer: '1',answer: 'Yes'},
		{pkanswer: '2',answer: 'No'}
	]
	//
	hideActivities: boolean = true;
	hideAdditionalInformation = true;
	hideAreaSelect: boolean = false;
	hideButtonNext: boolean = true;
	hideButtonSaveVisitor: boolean = false;
	hideCompanySupplier: boolean = false;
	hideButtonClose: boolean = true;
	hideCriticalWork: boolean = false;
	hideDocuments: boolean = true;
	hideEquipmentsVehicles: boolean = true;
	hideForeignVisit: boolean = false;
	hideGeneralInformation: boolean = false;
	hideIdentificationType: boolean = false;
	hideNotFoundProject: boolean = false;
	hideOriginBuilding: boolean = true;
	hideOriginSite: boolean = true;
	hideProjectSelect: boolean = false;
	hideRequiredIDPO: boolean = false;
	hideSchedule: boolean = true;
	hideSendToApprove: boolean = false;
	hideStartToWork: boolean = false;
	hideSubtypesvisits: boolean = false;
	hideSupplierIncomeType: boolean = false;
	hideTemporalBadge: boolean = false;
	hideUploadVisitorPhoto: boolean = false;
	hideVisitorBadge: boolean = true;
	hideVisitorsCatalog: boolean = false;
	hideVisitorID: boolean = false;
	hideVisitorsOwner: boolean = false;
	hideVisitorPhone: boolean = false;
	hideVisitorPosition: boolean = false;
	hideVisitorSponsor: boolean = true;
	hideVisitorWorkdayID: boolean = false;
	isNewVisitor: boolean = true;
	isReadOnly: boolean = false;
	isFieldReadOnly: boolean = false;
	isReadOnlyID: boolean = false;
	isReadOnlyRequiredID: boolean = true;
	isReadOnlyVisitorName: boolean = false;
	isReadOnlyVisitorEmail: boolean = false;
	isReadOnlyWorkdayID: boolean = false;
	items: MenuItem[];
	lblEditingEquipment: boolean = false;
	lblEditingVehicle: boolean = false;
	listActivities: Array<IActivities> = [];
	listActvitiesTypes: Array<IActivitiesTypes> = [];
	listAreas: Array<IAreas> = [];
	listBuildings: Array<IBuildings> = [];
	listCompaniesSuppliers: Array<ICompanySuppliers> = [];
	listData: Array<IVisitors> = [];
	listDataEquipment: Array<IVisitorEquipment> = [];
	listDataVehicle: Array<IVisitorVehicle> = [];
	listDocumentsLoaded: DocumentsLoaded[] = [];
	listDocumentsTypes: Array<IDocumentsTypes> = [];
	listEquipmentTypes: Array<IEquipmentTypes> = [];
	listIdentificationTypes: Array<IIdentificationsTypes> = [];
	listOriginBuildings: Array<IBuildings> = [];
	listOriginSites: Array<ISites> = [];
	listProjects: Array<IProjects> = [];
	listSubtypesVisits: Array<ISubtypesVisits> = [];
	listSuppliersIncomeTypes: Array<ISuppliersIncomeTypes> = [];
	listVisitsTypes: Array<IVisitsTypes> = [];
	loading: boolean;
	maxDate: Date = new Date();
	minDate: Date = new Date();
	minimumTime: number = 0;
	max_characters: string;
	max_characters_50: string;
	max_characters_email: string;
	max_characters_phone: string;
	max_month: number;
	message: string;
	pk_visitor_equipments: number = 0;
    pk_visitor_vehicle: number = 0;
    readOnlyProject: boolean = false;
	searched: boolean = false;
	searching: boolean = false;
	selectedVisitType: boolean = false;
	startdatevisit: Date;
	station: string = 'TABLE';
	subtypeVisitText: string = '';
	temportalDates: Array<any> = [];
	valueCalendadar: Date;
	visit_name: string;
	constructor(
		private activeDirectoryService: ActiveDirectoryService,
		private activitiesService: ActivitiesService,
		private areasService: AreasService,
		private buildingsService: BuildingsService,
		private companySuppliersService: CompanySuppliersService,
		@Inject(MAT_DIALOG_DATA) public data: IVisits,
		private datePipe: DatePipe,
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<NewVisitComponent>,
		private documentsTypesService: DocumentsTypesService,
		private formBuilder: FormBuilder,
		private identificationstypesService: IdentificationsTypesService,
		private notificationService: NotificationService,
		private projectsService: ProjectsService,
		private propertyService: PropertiesService,
		private roleService: RolesService,
		private router: Router,
		private sitesService: SitesService,
		private subtypesVisitsService: SubtypesVisitsService,
		private suppliersIncomeTypesService: SuppliersIncomeTypesService,
		private translate: TranslateApplicationService,
		private visitsService: VisitsService,
		private visitsTypesService: VisitsTypesService,
		private uploadFileService: UploadFileService,
		private equipmentTypesService: EquipmentTypesService,
		private visitorEquipmentService: VisitorsEquipmentsService,
		private visitorVehicleService: VisitorsVehiclesService,
	) {
		this.formGroup = this.formBuilder.group({
			cbcalendar: [null, Validators.required],
			cbpkactivity: [
				data.fkactivity == null ? null : data.fkactivity,
				Validators.required,
			],
			cbpkactivitytype: [
				(data.fkactivitytype = null ? null : data.fkactivitytype),
			],
			cbpkarea: [
				data.fkarea == null ? null : data.fkarea,
				Validators.required,
			],
			cbpkbuildingtovisit: [
				data.fkbuilding == null ? null : data.fkbuilding,
				Validators.required,
			],
			cbpkcompanysupplier: [
				data.fkcompanysupplier == null ? null : data.fkcompanysupplier,
				Validators.required,
			],
			cbpkidentificationtype: [
				data.fkidentificationtype == null
					? null
					: data.fkidentificationtype,
				Validators.required,
			],
			cbpkoriginbuilding: [
				data.fk_origin_building == null
					? null
					: data.fk_origin_building,
			],
			cbpkoriginsite: [
				data.fk_origin_site == null ? null : data.fk_origin_site,
			],
			cbpkproject: [
				data.fkproject == null ? null : data.fkproject,
				Validators.required,
			],
			cbpksupplierincometype: [data.fksupplierincometype],
			cbsponsorusername: [],
			cbPKsubtypevisit: [data.fksubtypevisit],
			cbpkvisittype: [
				data.fkvisittype == null ? null : data.fkvisittype,
				Validators.required,
			],
			chknotfoundproject: [(data.project == '' || data.project == undefined) ? false : true],
			chkstarttowork: [
				data.startofwork == null ? false : data.startofwork,
			],
			chkvisitorforeignvisit: [false],
			chktemporarybadge: [false],
			dtenddatevisit: [null,Validators.required],
			dtstartdatevisit: [null,Validators.required],
			imgVisitorID: [],
			imgVisitorPhoto: [],
			txtdescription: [
				data.activitydescription == null
					? ''
					: data.activitydescription,
				Validators.pattern('.*[a-zA-Z].*'),
			],
			txt_emergency_contact_name: [''],
			txt_emergency_contact_number: [
				'',
				[Validators.maxLength(10), Validators.pattern('^[0-9]{10}$')],
			],
			txt_flight: [''],
			txt_food_restrictions: [''],
			txt_hotel_information: [''],
			txtproject: [
				data.project == null ? '' : data.project,
				[Validators.pattern('.*[a-zA-Z].*'), Validators.maxLength(255)],
			],
			txtsponsorname: [data.sponsorname],
			txtsponsorname2: [data.sponsorname2],
			txtvisitorbadge: [''],
			txtvisitoremail: [
				data.email == null ? '' : data.email,
				[
					Validators.required,
					Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
					Validators.maxLength(80),
				],
			],
			txtvisitorid: [
				'',
				[Validators.required, Validators.pattern('.*[0-9a-zA-Z].*')],
			],
			txtvisitorname: [
				data.visitorname == null ? '' : data.visitorname,
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[a-zA-Z].*'),
				],
			],
			txtvisitorphone: [
				data.phone == null ? '' : data.phone,
				[
					Validators.required,
					Validators.maxLength(10),
					Validators.minLength(10),
					Validators.pattern('^[0-9]{10}$'),
				],
			],
			txtvisitorposition: [
				data.position == null ? '' : data.position,
				[Validators.required, Validators.pattern('.*[a-zA-Z].*')],
			],
			txtvisitorworkdayid: [data.visitorworkdayid],
			pkvisit: [data.pkvisit == null ? 0 : data.pkvisit],
			pkvisitor: [0],
			employeename: [''],
			username: [''],
			workdayid: [''],
			employeenumber: [''],
			email: [''],
			position: [''],
			inpEmployeeSearch: [data.sponsorname == '' || 'undefined' || undefined ? null : ''],
			sponsorname: [''],
			sponsorusername: [''],
			sponsorworkdayid: [''],
			sponsoremployeenumber: [''],
			sponsoremail: [''],
			sponsorposition: [''],
			isnewvisitor: [true],
			cbVisitOwner: [null, Validators.required],
			cbEquipmentType: [null, Validators.required],
			txtBrand: [
				null,
				[
					Validators.required,
					Validators.maxLength(50),
					Validators.pattern('.*[0-9a-zA-Z].*'),
				],
			],
			txtModel: [
				null,
				[
					Validators.required,
					Validators.maxLength(50),
					Validators.pattern('.*[0-9a-zA-Z].*'),
				],
			],
			txtRequisitionID: [
				data.requisitionid == null ? '' : data.requisitionid,
				Validators.maxLength(50),
			],
			txtSerialNumber: [
				null,
				[
					Validators.required,
					Validators.maxLength(50),
					Validators.pattern('.*[0-9a-zA-Z].*'),
				],
			],
			txtMacAddress: [
				null,
				[
					Validators.required,
					Validators.maxLength(50),
					Validators.pattern(
						'^([0-9A-Fa-f]{2}[-]){5}([0-9A-Fa-f]{2})$',
					),
				],
			],
			txtMacAddress2: [
				null,
				[
					Validators.maxLength(50),
					Validators.pattern(
						'^([0-9A-Fa-f]{2}[-]){5}([0-9A-Fa-f]{2})$',
					),
				],
			],
			txtJustification: [
				null,
				[
					Validators.maxLength(256),
					Validators.pattern('.*[0-9a-zA-Z].*'),
				],
			],
			cbJustification: [null],
			txtVehicleBrand: [
				null,
				[
					Validators.required,
					Validators.maxLength(50),
					Validators.pattern('.*[0-9a-zA-Z].*'),
				],
			],
			txtVehicleModel: [
				null,
				[
					Validators.required,
					Validators.maxLength(50),
					Validators.pattern('.*[0-9a-zA-Z].*'),
				],
			],
			txtColor: [
				null,
				[
					Validators.required,
					Validators.maxLength(50),
					Validators.pattern('.*[0-9a-zA-Z].*'),
				],
			],
			txtLicensePlate: [
				null,
				[
					Validators.required,
					Validators.maxLength(50),
					Validators.pattern('.*[0-9a-zA-Z].*'),
				],
			],
			visittype: [''],
			fksponsor: [data.fksponsor == null ? 0 : data.fksponsor],
			txtRecordStatus: [data.recordstatus == null ? '' : data.recordstatus],
		});
		this.selectedVisitType = false;
  }
  
	ngOnInit(): void {
		this.loading = true;
		this.visitsTypesService.GetVisitsTypes().subscribe(
		(result: TransactionResult<IVisitsTypes[]>) => {
			if (result.success) {
				this.listVisitsTypes = result.data;
				// Set the max time to schedule a visit
				this.propertyService.GetPropertyByName('Max_schedule_month').subscribe(
				(result: TransactionResult<IProperties[]>) => {
					if (result.success) {
						this.max_month = Number(result.data[0].propertyvalue);
						this.maxDate.setDate(this.maxDate.getDate());
						this.maxDate.setMonth(
							this.maxDate.getMonth() + this.max_month,
						);
						this.propertyService.GetPropertyByName('BUCKET_APPLICATION_PATH').subscribe(
						(result: TransactionResult<IProperties[]>) => {
							if (result.success) {
								this.applicationpath = result.data[0].propertyvalue;
								this.propertyService.GetPropertyByName('S3_Bucket_GET_FILE_URL_API').subscribe(
								(result: TransactionResult<IProperties[]>) => {
									if (result.success) {
										this.bucketS3Property = result.data[0].propertyvalue;
										this.GetVisitorsByVisit();
										this.loading = false;
                  } else {
                    this.loading = false;
                this.AlertProperties("Error", "WARNINGS.Property_not_found", "S3_Bucket_GET_FILE_URL_API");
                  }
								},
                (error: any) => {
                  this.loading = false;
                  this.ErrorAlert(error);
                });
              } else {
                this.loading = false;
                this.AlertProperties("Error", "WARNINGS.Property_not_found", "BUCKET_APPLICATION_PATH");
              }
						},
            (error: any) => {
              this.loading = false;
              this.ErrorAlert(error);
            });
          } else {
            this.loading = false;
				    this.Alert("Error", "ERROR.Error_retrieving_maximum_schedule_date_property");
          }
				},
				(error: any) => {
					this.loading = false;
					this.ErrorAlert(error);
				});
      }else {
				this.loading = false;
				this.Alert("Error", "ERROR.Get_visits_types_fail");
      }
		},
		(error: any) => {
			this.loading = false;
			this.ErrorAlert(error);
    });
		
		// Start with GetVisitsTypes() and finish in GetEquipmentsTypes()
		let max_char = this.translate.TranslateKey('max_characteres');
		this.max_characters = max_char.replace('{{ number_max }}', '255');
		this.max_characters_email = max_char.replace('{{ number_max }}', '80');
		this.max_characters_phone = max_char.replace('{{ number_max }}', '10');
		this.max_characters_50 = max_char.replace('{{ number_max }}', '50');
		// Fill the steps
		if (this.formGroup.controls.pkvisit.value != 0) {
			this.isReadOnly = true;
			this.buildingsService.GetAvailableBuildings(this.data.fk_origin_site).subscribe(
			(result: TransactionResult<IBuildings[]>) => {
				if (result.success) {
					this.listOriginBuildings = result.data;
				}
			},
			(error: any) => {
				this.ErrorAlert(error);
				this.loading = false;
			});
			let temporallDates = [];
			temporallDates.push(new Date(this.data.startdatevisit));
			temporallDates.push(new Date(this.data.enddatevisit));
			this.formGroup.controls.cbcalendar.setValue(temporallDates);
			let temporalStartHourTime = new Date(this.data.strstartdatevisit);
			let temporalStartHour =
				(temporalStartHourTime.getHours().toString().length == 1
					? '0' + temporalStartHourTime.getHours()
					: temporalStartHourTime.getHours().toString()) +
				':' +
				(temporalStartHourTime.getMinutes().toString().length == 1
					? '0' + temporalStartHourTime.getMinutes()
					: temporalStartHourTime.getMinutes().toString());
			let temporalEndHourTime = new Date(this.data.strenddatevisit);
			let temporalEndHour =
				(temporalEndHourTime.getHours().toString().length == 1
					? '0' + temporalEndHourTime.getHours()
					: temporalEndHourTime.getHours().toString()) +
				':' +
				(temporalEndHourTime.getMinutes().toString().length == 1
					? '0' + temporalEndHourTime.getMinutes()
					: temporalEndHourTime.getMinutes().toString());
			this.formGroup.controls.dtstartdatevisit.setValue(
				temporalStartHour,
			);
			this.formGroup.controls.dtenddatevisit.setValue(temporalEndHour);
			this.dateFrom = this.datePipe.transform(
				this.formGroup.controls.cbcalendar.value[0],
				'fullDate',
			);
			this.dateTo = this.datePipe.transform(
				this.formGroup.controls.cbcalendar.value[1],
				'fullDate',
			);
			
		}
		
  }
  
	ngAfterViewInit(): void {
		// function to change the modal size
		jQuery('.cdk-overlay-pane').removeAttr('style', '');
		jQuery('.cdk-overlay-pane').attr(
			'style',
			'max-width: none; width: 90vw; position: static; overflow: scroll;',
		);
		this.GetIdentificationsTypes();
		if(this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() != 'draft'.toLocaleLowerCase() &&
		this.formGroup.controls.txtRecordStatus.value.trim() != ''){
			this.GetEquipments();
		}
  }

  	CountExtra(event){
		this.contExtraInfo = event.target.value.length
	}
  
	AddVisitor() {
    this.loading = true;
		this.visitsService.SetVisitor(this.formGroup.value).subscribe(
			(result: TransactionResult<number>) => {
				if (result.success) {
					this.loading = true;
					this.formGroup.controls.pkvisitor.setValue(result.data);
					this.formGroup.controls.visittype.setValue(this.visit_name);
					this.visitsService
						.SetVisitorVisit(this.formGroup.value)
						.subscribe(
							(result: TransactionResult<boolean>) => {
                if (result.success) {
									if (this.visit_name == 'Jabil visitors') {
										this.SetSponsor();
                  }
                  
                  if (this.visit_name == 'Suppliers') {
                    this.ClearSupplierVisitorFields();
                  }
									this.formGroup.controls.txtRecordStatus.setValue('none');
									this.GetVisitorsByVisit();
                  this.isReadOnly = true;
									this.Alert('Success', 'COMPLETE');
                } else {
                  this.Alert("Error", "MYREQUEST.Save_visitor_information_fail");
                  this.loading = false;
                }
							},
							(error: any) => {
								this.loading = false;
								this.ErrorAlert(error);
							},
						);
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Save_visitor_information_fail");
        }
			},
			(error: any) => {
				this.loading = false;
			},
		);
    this.loading = true;
    this.formGroup.controls.isnewvisitor.setValue(true);
	}
	AddVisitorEquipment() {
		this.loading = true;
		this.formGroup.controls.txtJustification.value;
		this.formGroup.controls.txtMacAddress.value;
		this.formGroup.controls.txtMacAddress2.value;
		if (
			(this.formGroup.controls.txtMacAddress.value !=
			this.formGroup.controls.txtMacAddress2.value) || this.formGroup.controls.txtJustification.value != ""
		) {
			this.visitorEquipmentService
				.AddVisitorEquipment(
					this.formGroup.value,
					this.pk_visitor_equipments,
				)
				.subscribe(
					(result: TransactionResult<IVisitorEquipment[]>) => {
						if (result.success) {
							this.Alert('Success', 'COMPLETE');
							this.ClearEquipmentForm();
							this.GetEquipments();
            } else {
              this.loading = false;
              this.Alert("Error", "MYREQUEST.Save_IT_equipment_information_fail");
            }
					},
					(error: any) => {
						this.ErrorAlert(error);
						this.loading = false;
					},
				);
		} else {
			this.Alert('Warning', 'WARNINGS.MAC_address_must_different');
			this.loading = false;
		}
	}
	AddVisitorVehicle() {
		this.loading = true;
		this.visitorVehicleService
			.AddVisitorVehicle(this.formGroup.value, this.pk_visitor_vehicle)
			.subscribe(
				(result: TransactionResult<IVisitorVehicle[]>) => {
					if (result.success) {
						this.Alert('Success', 'COMPLETE');
						this.ClearVehicleForm();
						this.GetVehicles();
          } else {
            this.loading = false;
            this.Alert("Error", "MYREQUEST.Save_vehicle_information_fail");
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				},
			);
	}
	Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
  }

  AlertProperties(title: string, message: string, property: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message) + ": " + property,
			shown: true,
		});
  }
  
	ChangeEmployeeSearch(event) {
		jQuery('.p-dropdown').css('max-width', '300px');
		this.GetEmployeeByDistinguishedname(
			event.value.distinguishedname.toString(),
		);
	}

	ChangeNotFoundProject() {
		if (!this.formGroup.controls.chknotfoundproject.value) {
      this.formGroup.controls.txtproject.setValue('');
      this.readOnlyProject = false;
		} else {
      this.display_not_found_project = true;
      this.formGroup.controls.cbpkproject.setValue(0);
      this.readOnlyProject = true;
		}
	}

	ChangeSponsorSearch(event) {
		jQuery('.p-dropdown').css('max-width', '300px');
		this.GetSponsorByDistinguishedname(
			event.value.distinguishedname.toString(),
		);
  }
  

   ChangeMacAddress(answer: any){
		this.loading = true;
		if(answer == 1){
			this.hideJustification = true;
			this.hideMacaddres = false;
			this.formGroup.controls.txtJustification.setValue('');
		}else if(answer == 2){
			this.hideMacaddres = true;
			this.hideJustification = false;
			this.formGroup.controls.txtMacAddress.setValue('');
			this.formGroup.controls.txtMacAddress2.setValue('');
		}
		this.loading = false;
	}

	ChangePlace(pkplace: any) {
		this.loading = true;
		this.visitsService.GetActvitiesTypes().subscribe(
		(result: TransactionResult<IActivitiesTypes[]>) => {
			if (result.success) {
				this.listActvitiesTypes = result.data;
				let activityType = this.listActvitiesTypes.filter(
					(element) => element.pkactivitytype == pkplace,
				);
				if (activityType[0].activitytype == 'Area') {
					this.hideAreaSelect = true;
					this.hideProjectSelect = false;
					this.formGroup.controls.cbpkproject.setValue(0);
					this.hideNotFoundProject = true;
					this.formGroup.controls.chknotfoundproject.setValue(false);
					this.ChangeNotFoundProject();
				} else {
					this.hideAreaSelect = false;
					this.hideProjectSelect = true;
					this.formGroup.controls.cbpkarea.setValue(0);
					
					if (this.visit_name == 'Customers')     
						this.hideNotFoundProject = false;
				}
				this.loading = false;
      } else {
        this.loading = false;
        this.Alert("Error", "MYREQUEST.Error_getting_the_places_to_visit");
      }
		},
    (error: any) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }
  
	ChangeSite(pksite: number) {
		this.listOriginBuildings = [];
		this.formGroup.controls;
		if(this.data.pkvisit == null || this.data.pkvisit == undefined || this.data.pkvisit == 0){
			this.formGroup.controls.cbpkoriginbuilding.setValue(0);
		}
		
		if (this.data.fk_origin_building == 0) {
			this.formGroup.controls.cbpkoriginbuilding.setValue(0);
		}
		this.buildingsService.GetAvailableBuildings(pksite).subscribe(
		(result: TransactionResult<IBuildings[]>) => {
			if (result.success) {
				this.listOriginBuildings = result.data;
      } else {
        this.loading = false;
        this.Alert("Error", "MYREQUEST.Failed_to_retrieve_available_buildings");
      }
		},
		(error: any) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
  }
  
	ChangeStatusEquipment(item: any) {
		this.loading = true;
		this.visitorEquipmentService
			.ChangeStatusEquipment(item.pk_visitor_equipments, item.available)
			.subscribe(
				(result: TransactionResult<any>) => {
					if (result.success) {
						this.Alert('Success', 'COMPLETE');
						this.ClearEquipmentForm();
						this.GetEquipments();
          }else {
            this.loading = false;
            this.Alert("Error", "MYREQUEST.Failed_to_update_equipment_status");
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				});
	}
	ChangeStatusVehicle(item: any) {
		this.loading = true;
		this.visitorVehicleService
			.ChangeStatusVehicle(item.pk_visitor_vehicle, item.available)
			.subscribe(
				(result: TransactionResult<any>) => {
					if (result.success) {
						this.Alert('Success', 'COMPLETE');
						this.ClearVehicleForm();
						this.GetVehicles();
          } else {
            this.loading = false;
            this.Alert("Error", "MYREQUEST.Failed_to_update_vehicle_status");
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				},
			);
	}
	ChangeStatusVisitor(item: IVisitors) {
		this.loading = true;
		this.visitsService
			.ChangeVisitorStatus(item)
      .subscribe((result: TransactionResult<boolean>) => {
        this.loading = false;
				if (result) {
					this.Alert('Success', 'COMPLETE');
        } else {
          this.Alert('Error', 'MYREQUEST.Error_change_status_visitor');
        }
			},
      (error: any) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
	}
	ClearEquipmentForm() {
		this.lblEditingEquipment = false;
		this.pk_visitor_equipments = 0;
		if (this.visit_name == 'Suppliers') {
			this.formGroup.controls.cbVisitOwner.setValue(0);
		}
		this.formGroup.controls.cbEquipmentType.setValue(0);
		this.formGroup.controls.txtBrand.setValue('');
		this.formGroup.controls.txtModel.setValue('');
		this.formGroup.controls.txtSerialNumber.setValue('');
		this.formGroup.controls.txtMacAddress.setValue('');
		this.formGroup.controls.txtMacAddress2.setValue('');
		this.formGroup.controls.txtJustification.setValue('');
		this.formGroup.controls.cbJustification.setValue(0);
		if (this.visit_name == 'Customers') {
			this.hideJustification = true;
		this.hideMacaddres = true;
		}
		
  }
  
  ClearSupplierVisitorFields() {
    this.formGroup.controls.pkvisitor.setValue(0);
    this.formGroup.controls.txtvisitorname.setValue('');
    this.formGroup.controls.txtvisitoremail.setValue('');
    this.formGroup.controls.txtvisitorphone.setValue('');
    this.formGroup.controls.cbpkidentificationtype.setValue([]);
    this.formGroup.controls.txtvisitorposition.setValue('');
    this.formGroup.controls.txtvisitorid.setValue('');
    this.formGroup.controls.imgVisitorID.setValue(null);
    this.formGroup.controls.imgVisitorPhoto.setValue(null);
    this.formGroup.controls.inpEmployeeSearch.reset('');
    this.formGroup.controls.isnewvisitor.setValue(true);
    this.formGroup.controls.chktemporarybadge.setValue(false);
    this.isReadOnlyID = false;
    jQuery('.clearDropDownSearchEmployee').click();
    this.enableBtnAddVisitor = false;
    this.clearVisitorFields = false;
  }

	ClearVehicleForm() {
		this.lblEditingVehicle = false;
		this.pk_visitor_vehicle = 0;
		if (this.visit_name == 'Suppliers') {
			this.formGroup.controls.cbVisitOwner.setValue(0);
		}
		this.formGroup.controls.txtVehicleBrand.setValue('');
		this.formGroup.controls.txtVehicleModel.setValue('');
		this.formGroup.controls.txtColor.setValue('');
		this.formGroup.controls.txtLicensePlate.setValue('');
  }
  
	Close() {
		this.dialogRef.close(true);
	}

	CloseMessageNotFoundProject(show: boolean) {
		this.display_not_found_project = show;
	}

	CreateVisit() {
		this.visitsService
			.CreateVisit(this.formGroup.value)
			.subscribe((result: TransactionResult<number>) => {
				if (result.success) {
					this.formGroup.controls.pkvisit.setValue(result.data);
					this.isReadOnly = true;
					this.AddVisitor();
        } else {
          this.loading = false;
          this.Alert('Error', 'MYREQUEST.Error_creating_visit');
        }
			},
      (error: any) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
  }
  
	EditEquipment(item: any) {
		this.lblEditingEquipment = true;
		this.hideJustification = true;
		this.hideMacaddres = true;
		this.pk_visitor_equipments = item.pk_visitor_equipments;
		this.formGroup.controls.cbVisitOwner.setValue(item.fk_visitor);
		this.formGroup.controls.cbEquipmentType.setValue(item.fk_type_equipment);
		this.formGroup.controls.txtBrand.setValue(item.brand);
		this.formGroup.controls.txtModel.setValue(item.model);
		this.formGroup.controls.txtSerialNumber.setValue(item.serial_number);
		if(item.mac_address == ''){
			this.hideJustification = false;
			this.formGroup.controls.txtJustification.setValue(item.justification);
			this.formGroup.controls.cbJustification.setValue('No');
		}else{
			this.hideMacaddres = false;
			this.formGroup.controls.txtMacAddress.setValue(item.mac_address);
			this.formGroup.controls.txtMacAddress2.setValue(item.mac_address2);
			this.formGroup.controls.cbJustification.setValue('Yes');
		}
		
		
  }
  
	EditVehicle(item: any) {
		this.lblEditingVehicle = true;
		this.pk_visitor_vehicle = item.pk_visitor_vehicle;
		this.formGroup.controls.cbVisitOwner.setValue(item.fk_visitor);
		this.formGroup.controls.txtVehicleBrand.setValue(item.brand);
		this.formGroup.controls.txtVehicleModel.setValue(item.model);
		this.formGroup.controls.txtColor.setValue(item.color);
		this.formGroup.controls.txtLicensePlate.setValue(item.license_plate);
  }
  
	EditVisitor(item: IVisitors) {
		this.formGroup.controls.isnewvisitor.setValue(false);
		this.formGroup.controls.pkvisitor.setValue(item.pkvisitor);
		this.formGroup.controls.txtvisitorname.setValue(item.visitorname);
		this.formGroup.controls.txtvisitoremail.setValue(item.email);
		this.formGroup.controls.txtvisitorphone.setValue(item.phone);
		this.formGroup.controls.cbpkidentificationtype.setValue(
			item.fkidentificationtype,
		);
		this.formGroup.controls.txtvisitorposition.setValue(item.position);
		this.formGroup.controls.txtvisitorid.setValue(item.idnumber);
		this.formGroup.controls.imgVisitorID.setValue(true);
		this.formGroup.controls.imgVisitorPhoto.setValue(true);
		this.formGroup.controls.chktemporarybadge.setValue(item.temporarybadge);
		this.formGroup.controls.chkvisitorforeignvisit.setValue(
			item.foreignvisit,
		);
		this.formGroup.controls.inpEmployeeSearch.setValue('');
    this.isReadOnlyID = true;
    this.enableBtnAddVisitor = true;
    this.clearVisitorFields = true;
    this.formGroup.controls.isnewvisitor.setValue(false);
  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
	}
  
	FillInputsForNotJabilVisitors(): void {
		this.loading = true;
		this.formGroup.controls.pkvisitor.setValue(
			this.dataNotJabilVisitor[0].pkvisitor,
		);
		this.formGroup.controls.txtvisitorname.setValue(
			this.dataNotJabilVisitor[0].visitorname,
		);
		this.formGroup.controls.txtvisitoremail.setValue(
			this.dataNotJabilVisitor[0].email,
		);
		this.formGroup.controls.txtvisitorphone.setValue(
			this.dataNotJabilVisitor[0].phone,
		);
		this.formGroup.controls.cbpkidentificationtype.setValue(
			this.dataNotJabilVisitor[0].fkidentificationtype,
		);
		this.formGroup.controls.txtvisitorposition.setValue(
			this.dataNotJabilVisitor[0].position,
		);
		this.formGroup.controls.txtvisitorid.setValue(
			this.dataNotJabilVisitor[0].idnumber,
		);
		this.formGroup.controls.cbVisitOwner.setValue(
			this.dataNotJabilVisitor[0].pkvisitor,
		);
		this.formGroup.controls.imgVisitorID.setValue(true);
		this.formGroup.controls.isnewvisitor.setValue(false);
		this.formGroup.controls.txt_flight.setValue(
			this.dataNotJabilVisitor[0].flight,
		);
		this.formGroup.controls.txt_emergency_contact_name.setValue(
			this.dataNotJabilVisitor[0].emergency_contact_name,
		);
		this.formGroup.controls.txt_emergency_contact_number.setValue(
			this.dataNotJabilVisitor[0].emergency_contact_number,
		);
		this.formGroup.controls.txt_hotel_information.setValue(
			this.dataNotJabilVisitor[0].hotel_information,
		);
		this.formGroup.controls.txt_food_restrictions.setValue(
			this.dataNotJabilVisitor[0].food_restrictions,
		);
		this.formGroup.controls.chktemporarybadge.setValue(
			this.dataNotJabilVisitor[0].temporarybadge,
		);
		this.formGroup.controls.txtvisitorbadge.setValue(
			this.dataNotJabilVisitor[0].badge,
		);
		this.formGroup.controls.txtvisitorworkdayid.setValue(
			this.dataNotJabilVisitor[0].visitorworkdayid,
		);
		this.isReadOnlyID = true;
		this.loading = false;
  }
  
	GetActivitiesTypes() {
		this.visitsService.GetActvitiesTypes().subscribe(
		(result: TransactionResult<IActivitiesTypes[]>) => {
			if (result.success) {
				this.listActvitiesTypes = result.data;
				this.GetAvailableActivities();
      } else {
        this.loading = false;
        this.Alert('Error', 'MYREQUEST.Error_retrieving_the_activity_types_list');
      }
		},
    (error: any) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }
  
	GetAvailableActivities() {
		if(this.data.activity == 'N/A'){
			this.formGroup.controls.cbpkactivity.setValue(0);
		}
		this.activitiesService.GetAvailableActivities().subscribe(
		(result: TransactionResult<IActivities[]>) => {
			if (result.success) {
				this.listActivities = result.data;
				this.GetEquipmentsTypes();
      } else {
        this.loading = false;
        this.Alert('Error', 'MYREQUEST.Failed_to_retrieve_available_activities');
      }
		},
    (error: any) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }
  
	GetAvailableAreas() {
		this.areasService.GetAreasByBuilding(this.formGroup.controls.cbpkbuildingtovisit.value).subscribe(
		(result: TransactionResult<IAreas[]>) => {
			if (result.success) {
				this.listAreas = result.data;
				this.GetAvailableProjects();
      } else {
        this.loading = false;
        this.Alert('Error', 'MYREQUEST.Failed_to_retrieve_available_areas');
      }
		},
    (error: any) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }
  
	GetAvailableProjects() {
		this.projectsService.GetProjectsByBuilding(this.formGroup.controls.cbpkbuildingtovisit.value).subscribe(
		(result: TransactionResult<IProjects[]>) => {
			if (result.success) {
				this.listProjects = result.data;
				if (this.formGroup.controls.txtproject.value.trim() != '') {
					this.formGroup.controls.cbpkproject.setValue(0);
					this.readOnlyProject = true;
				}
      } else {
        this.loading = false;
        this.Alert('Error', 'MYREQUEST.Failed_to_retrieve_available_projects');
      }
		},
    (error: any) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }
  
	GetBuildingsBySite() {
		this.buildingsService.GetAvailableBuildings().subscribe(
		(result: TransactionResult<IBuildings[]>) => {
			if (result.success) {
				this.listBuildings = [];
				this.listBuildings = result.data;
				this.loading = false;
      } else {
        this.loading = false;
        this.Alert('Error', 'MYREQUEST.Error_retrieving_available_buildings_by_site');
      }
		},
		(error: any) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
  }
  
	GetCompanySuppliers() {
		this.companySuppliersService.GetAvailableCompanySuppliers().subscribe(
		(result: TransactionResult<ICompanySuppliers[]>) => {
			if (result.success) {
				this.listCompaniesSuppliers = result.data;
				this.GetSuppliersIncomeTypes();
      } else {
        this.loading = false;
        this.Alert('Error', 'MYREQUEST.Error_retrieving_available_companies_suppliers');
      }
		},
		(error: any) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
  }
  
	GetDatesCalendar() {
		let dates = this.formGroup.controls.cbcalendar.value;
		this.dateFrom = this.datePipe.transform(dates[0], 'fullDate');
		this.dateTo = this.datePipe.transform(dates[1], 'fullDate');
  }
  
  GetDocumentsTypes() {
    this.loading = true;
		this.documentsTypesService.GetDocumentsTypesBySite().subscribe(
			(result: TransactionResult<IDocumentsTypes[]>) => {
				if (result.success) {
					this.listDocumentsTypes = result.data.filter((element) => element.available == true);
					// Finish loading to Suppliers
					if (
						this.formGroup.controls.chkvisitorforeignvisit.value ==
						true
					) {
						this.listDocumentsTypes.forEach((element) => {
							element.available =
								element.required_foreign_visit == false
									? false
									: true;
						});
					}
          this.ValidateDocumentsLoadWithActivitySelected();
        } else {
          this.loading = false;
          this.Alert('Error', 'MYREQUEST.Error_retrieving_list_of_document_types');
        }
			},
			(error: any) => {
				this.ErrorAlert(error);
				this.loading = false;
			},
		);
  }
  
	GetDocumentsLoadedByVisit() {
		this.visitsService
			.GetDocumentsLoadedByVisit(this.formGroup.controls.pkvisit.value)
			.subscribe(
				(result: TransactionResult<IDocumentsSuppliersVisits[]>) => {
					if (result.success) {
						result.data.forEach((element) => {            
              this.listDocumentsTypes.forEach(
								(documentLoaded) => {
									if (element.fk_document_type == documentLoaded.pkdocumenttype) {
										documentLoaded.loaded = true;
									}
								},
							);
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.Alert('Error', 'MYREQUEST.Error_retrieving_list_of_document_loaded');
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				},
			);
  }
  
	GetEmployeeByDistinguishedname(value: string) {
    this.loading = true;
    var arr: IEmployeesInActiveDirectory[] = [];
		this.activeDirectoryService
			.GetEmployeeByDistinguishedname(value)
			.subscribe(
				(result: TransactionResult<IEmployeesInActiveDirectory[]>) => {
          if (result.success) {
            var jsonObj = JSON.parse(result.data.toString());
            arr = jsonObj.data;

						this.formGroup.controls.employeename.setValue(
							arr[0].name,
						);
						this.formGroup.controls.username.setValue(
							arr[0].userName,
						);
						this.formGroup.controls.workdayid.setValue(
							arr[0].workdayId,
						);
						this.formGroup.controls.employeenumber.setValue(
							arr[0].employeeNumber,
						);
						if (arr[0].email != null) {
							this.formGroup.controls.email.setValue(
								arr[0].email,
							);
						}
						this.formGroup.controls.position.setValue(
							arr[0].position,
						);
						if (this.visit_name == 'Jabil visitors') {
							this.formGroup.controls.txtvisitorworkdayid.setValue(
								arr[0].workdayId,
							);
							this.formGroup.controls.txtvisitorname.setValue(
								arr[0].name,
							);
							this.formGroup.controls.txtvisitoremail.setValue(
								arr[0].email,
							);
						}
						this.formGroup.controls.txtsponsorname.setValue(
							'(' +
								this.formGroup.controls.workdayid.value +
								') - ' +
								this.formGroup.controls.employeename.value,
						);
						this.formGroup.controls.inpEmployeeSearch.setValue('');
						this.loading = false;
          }else{
            this.loading = false;
            // TODO: Add generic translate
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				},
			);
  }
  
	GetSponsorByDistinguishedname(value: string) {
    this.loading = true;
    var arr: IEmployeesInActiveDirectory[] = [];
		this.activeDirectoryService
			.GetEmployeeByDistinguishedname(value)
			.subscribe(
				(result: TransactionResult<IEmployeesInActiveDirectory[]>) => {
          this.loading = false;
          if (result.success) {
            var jsonObj = JSON.parse(result.data.toString());
            arr = jsonObj.data;

						this.formGroup.controls.sponsorname.setValue(
							arr[0].name,
						);
						this.formGroup.controls.sponsorusername.setValue(
							arr[0].userName,
						);
						this.formGroup.controls.sponsorworkdayid.setValue(
							arr[0].workdayId,
						);
						this.formGroup.controls.sponsoremployeenumber.setValue(
							arr[0].employeeNumber,
						);
						if (arr[0].email != null) {
							this.formGroup.controls.sponsoremail.setValue(
								arr[0].email,
							);
						}
						this.formGroup.controls.sponsorposition.setValue(
							arr[0].position,
						);
						this.formGroup.controls.txtsponsorname2.setValue(
							'(' +
								this.formGroup.controls.workdayid.value +
								') - ' +
								this.formGroup.controls.employeename.value,
						);
						this.formGroup.controls.inpEmployeeSearch.setValue('');
						this.loading = false;
					}else{
            this.loading = false;
            // TODO: Add generic translate
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				},
			);
  }
  
	GetEquipments() {
		if (this.visit_name != 'Customers') {
			this.hideMacaddres = false;
			this.hideCbjustification = true;
		}else{
			this.hideMacaddres = true;
		}
		this.listDataEquipment = [];
		this.visitorEquipmentService
			.GetList(this.formGroup.controls.pkvisit.value)
			.subscribe(
				(result: TransactionResult<IVisitorEquipment[]>) => {
					if (result.success) {
						this.listDataEquipment = result.data;
						this.GetVehicles();
          } else {
            this.loading = false;
            this.Alert('Error', 'MYREQUEST.Error_retrieving_list_of_IT_equipment_by_visitor');
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				},
			);
  }
  
	GetEquipmentsTypes() {
		this.equipmentTypesService.GetList().subscribe(
			(result: TransactionResult<IEquipmentTypes[]>) => {
				if (result.success) {
					result.data.forEach((obj) => {
						if (obj.available) this.listEquipmentTypes.push(obj);
					});
					this.loading = false;
        } else {
          this.loading = false;
          this.Alert('Error', 'MYREQUEST.Error_retrieving_list_of_IT_equipment_types');
        }
			},
			(error: any) => {
				this.ErrorAlert(error);
				this.loading = false;
			},
		);
  }
  
	GetIdentificationsTypes() {
		this.identificationstypesService.GetAvailableIdentificationsTypes().subscribe(
		(result: TransactionResult<IIdentificationsTypes[]>) => {
			if (result.success) {
				this.listIdentificationTypes = result.data;
				this.GetActivitiesTypes();
      } else {
        this.loading = false;
        this.Alert('Error', 'MYREQUEST.Error_retrieving_list_of_available_identification_types');
      }
		},
		(error: any) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
	}
	GetAvailableSites() {
		this.sitesService
			.GetAvailableSites()
			.subscribe((result: TransactionResult<ISites[]>) => {
				if (result.success) {
					this.listOriginSites = result.data;
        } else {
          this.loading = false;
          this.Alert('Error', 'ERROR.Error_retrieving_list_of_available_sites');
        }
			},
      (error: any) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
  }
  
	GetSubtypesVisits(): void {
		this.subtypesVisitsService
			.GetSubtypesVisits()
			.subscribe((result: TransactionResult<ISubtypesVisits[]>) => {
				if (result.success) {
					this.listSubtypesVisits = result.data;
					// Close the loading after to select the visit type
					this.loading = false;
        }else{
          this.loading = false;
          this.Alert('Error', 'MYREQUEST.Error_retrieving_list_of_subtypes_visits');
        }
			},
      (error: any) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
  }
  
	GetSuppliersIncomeTypes() {
		this.suppliersIncomeTypesService
			.GetSuppliersIncomeTypes()
			.subscribe((result: TransactionResult<ISuppliersIncomeTypes[]>) => {
				if (result.success) {
					this.listSuppliersIncomeTypes = result.data;
        } else {
          this.loading = false;
          this.Alert('Error', 'MYREQUEST.Error_retrieving_list_of_suppliers_income_types');
        }
			},
      (error: any) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
  }
  
	GetVehicles() {
		this.listDataVehicle = [];
		this.visitorVehicleService
			.GetList(this.formGroup.controls.pkvisit.value)
			.subscribe(
				(result: TransactionResult<IVisitorVehicle[]>) => {
					if (result.success) {
						this.listDataVehicle = result.data;
						// Close the loading after to select the visit type. Finish loading

						this.loading = false;
          } else {
            this.loading = false;
            this.Alert('Error', 'MYREQUEST.Error_retrieving_list_of_vehicles_by_visitor');
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				},
			);
  }
  
	GetVisitorsByVisit() {
		if(this.formGroup.controls.txtRecordStatus.value.trim() != ''){
			this.listData = [];
			this.visitsService.GetVisitorsByVisit(this.formGroup.controls.pkvisit.value).subscribe(
			(result: TransactionResult<IVisitors[]>) => {
				
				if (result.success) {
					if(this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() != 'draft'.toLocaleLowerCase() && 
					this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() != '' && this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() != 'none'.toLocaleLowerCase())
						
					if (this.visit_name == 'Suppliers') {
						result.data.forEach((element) => {
							this.uploadFileService.GetFile(this.applicationpath,element.strimageID,this.bucketS3Property).subscribe(
							(result: TransactionResult<any>) => {
								if (result.success) {
									element.strimageID = result.data;
								}
							});
							this.uploadFileService.GetFile(this.applicationpath,element.strimagePhoto,this.bucketS3Property).subscribe(
							(result: TransactionResult<any>) => {
								if (result.success) {
									element.strimagePhoto = result.data;
								}
							});
						});
          } else {
            this.isFieldReadOnly = true;
          }
					this.listData = result.data;
					if (this.listData.length > 0) {
						this.hideButtonNext = false;
					}
					this.visit_name = this.listVisitsTypes.filter(
						(element) =>
							element.pkvisittype == this.data.fkvisittype,
					)[0].visittype;
					if (this.formGroup.controls.pkvisit.value != 0) {
						switch (this.visit_name) {
							case 'Not-Jabil visitors':
								this.dataNotJabilVisitor = result.data;
								this.FillInputsForNotJabilVisitors();
								break;
							case 'Customers':
								this.formGroup.controls.inpEmployeeSearch.valid;
								debugger;
								this.dataNotJabilVisitor = result.data;
								this.FillInputsForNotJabilVisitors();
								break;
							case 'Jabil visitors':
								this.dataNotJabilVisitor = result.data;
								this.FillInputsForNotJabilVisitors();
								break;
							case 'Recruitment':
								this.dataNotJabilVisitor = result.data;
								this.FillInputsForNotJabilVisitors();
								break;
						}
					}
        } else {
          this.loading = false;
          this.Alert('Error', 'MYREQUEST.Failed_to_retrieve_visitors_per_visit');
        }
				this.loading = false;
			},
      (error: any) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
		}
  }

  	CreateCustomerVisit(){
		this.loading = true;
		if (this.formGroup.controls.pkvisit.value == 0) {
			this.visitsService.CreateVisit(this.formGroup.value).subscribe(
				(result: TransactionResult<number>) => {
					if (result.success) {
						this.formGroup.controls.pkvisit.setValue(result.data);
						this.data.pkvisit = result.data;
						this.loading = false;
						this.AddVisitor();
						
					} 
					else{
						this.loading = false;
						this.Alert("Error", "MYREQUEST.Error_creating_new_visit");
		  			}
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				},
			);
		}
	}
  
	Next() {
		this.loading = true;
		if (this.listData.length > 0 &&
		(this.formGroup.controls.cbpksupplierincometype.valid && this.visit_name == "Suppliers") ||
		(this.formGroup.controls.cbPKsubtypevisit.value != null && this.visit_name == "Not-Jabil visitors")) {
			this.activeIndex = this.activeIndex + 1;
		} else  if(this.visit_name != 'Recruitment' && this.visit_name != 'Jabil visitors' && this.visit_name != 'Customers'){
			this.Alert('Warning', 'WARNINGS.Empty_fields');
		}
		if (this.visit_name == 'Recruitment' || this.visit_name == 'Jabil visitors' || this.visit_name == 'Customers') {
			this.activeIndex = this.activeIndex + 1;
		}
		switch (this.visit_name) {
			case 'Suppliers':
				if (this.activeIndex == 1) {
					if((this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() == 'draft'.toLocaleLowerCase() ||
					this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() == 'none'.toLocaleLowerCase()))
						this.UpdateGeneralInformation();
					this.isReadOnly = true;
					this.hideGeneralInformation = true;
					this.hideSchedule = false;
				}
				if(this.activeIndex == 2){
					if (
						this.formGroup.controls.cbcalendar.value[0] != null &&
						this.formGroup.controls.cbcalendar.value[1] != null &&
						this.formGroup.controls.dtenddatevisit.valid &&
						this.formGroup.controls.dtstartdatevisit.valid 
					) {
						if (!this.data.isViewing) this.UpdateScheduleVisit();
						this.hideSchedule = true;
						this.hideActivities = false;
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideSchedule = false;
						this.hideActivities = true;
					}
				}
				if (this.activeIndex == 3) {
					if (
						this.formGroup.controls.cbpkvisittype.valid &&
						this.formGroup.controls.cbpkarea.valid &&
						this.formGroup.controls.cbpkproject.valid &&
						this.formGroup.controls.cbpkactivity.valid && 
						this.formGroup.controls.cbpkactivity.value != 0 && 
						this.formGroup.controls.txtdescription.value.trim() != ''
					) {
						if (!this.data.isViewing) {
							this.UpdateActivities();
            				this.GetDocumentsTypes();
						}
            //this.ValidateDocumentsLoadWithActivitySelected();
						this.hideDocuments = false;
						this.hideActivities = true;
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideDocuments = true;
						this.hideActivities = false;
					}
				}
          if (this.activeIndex == 4) {
            let allLoaded = false;
            if (!this.data.isViewing) {
              for (let x = 0; x < this.listDocumentsTypes.length; x++) {
                  if (this.formGroup.controls.chkvisitorforeignvisit.value == true) {
                    if (this.listDocumentsTypes[x].required_foreign_visit == true &&
                        this.listDocumentsTypes[x].loaded == true) {
                        allLoaded = true;
                    } 
                  else if (this.listDocumentsTypes[x].required_foreign_visit == true && 
                    this.listDocumentsTypes[x].loaded == false) {
                        allLoaded = false;
                        break;
                    }
                  } 
                else {
                  if (this.listDocumentsTypes[x].loaded == true && this.listDocumentsTypes[x].available == true) {
                    allLoaded = true;
                  } 
                  else if(this.listDocumentsTypes[x].loaded == false && this.listDocumentsTypes[x].available == true){
                    allLoaded = false;
                    break;
                  }
                }
              }
            } 
				else {
					allLoaded = true;
          		}
				if (allLoaded == true) {
					this.hideButtonNext = true;
					if (!this.data.isViewing)
						this.hideSendToApprove = false;
					else this.hideButtonClose = false;
						this.hideDocuments = true;
            this.hideEquipmentsVehicles = false;
            if (!this.data.isViewing) this.Alert('Success', 'COMPLETE');
            this.GetEquipments();
				} 
				else {
					this.Alert('Warning', 'WARNINGS.Empty_fields');
					this.activeIndex = this.activeIndex - 1;
				}
			}
			break;
			case 'Not-Jabil visitors':
				if (this.activeIndex == 1) {
					if(this.formGroup.controls.txtRequisitionID.value.trim() == '' && this.subtypeVisitText == 'Work'){
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideGeneralInformation = false;
						this.hideSchedule = true;
					}
					else{
						this.UpdateGeneralInformation();
						this.isReadOnly = true;
						if (
							this.formGroup.controls.txtvisitorname.valid &&
							this.formGroup.controls.txtvisitoremail.valid &&
							this.formGroup.controls.txtvisitorphone.valid &&
							this.formGroup.controls.cbpkidentificationtype.valid &&
							this.formGroup.controls.txtvisitorposition.valid &&
							this.formGroup.controls.txtvisitorid.valid &&
							this.formGroup.controls.imgVisitorID.value == true
						) {
							if (!this.data.isViewing) {
								this.AddVisitor();
							}
							this.hideGeneralInformation = true;
							this.hideSchedule = false;
						} else {
							this.Alert('Warning', 'WARNINGS.Empty_fields');
							this.activeIndex = this.activeIndex - 1;
							this.hideGeneralInformation = false;
							this.hideSchedule = true;
						}
					}
				}
				if (this.activeIndex == 2) {
					if (
						this.formGroup.controls.cbcalendar.value[0] != null &&
						this.formGroup.controls.cbcalendar.value[1] != null &&
						this.formGroup.controls.dtenddatevisit.valid &&
						this.formGroup.controls.dtstartdatevisit.valid
					) {
						if (!this.data.isViewing) this.UpdateScheduleVisit();
						this.hideSchedule = true;
						this.hideActivities = false;
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideSchedule = false;
						this.hideActivities = true;
					}
				}
				if (this.activeIndex == 3) {
					if (
						this.formGroup.controls.cbpkvisittype.value != null &&
						(this.formGroup.controls.cbpkarea.value != null ||
							this.formGroup.controls.cbpkproject.value !=
								null) &&
						this.formGroup.controls.cbpkactivity.value != null &&
						this.formGroup.controls.txtdescription.value.trim() != ''
					) {
						this.GetEquipments();
						switch (this.subtypeVisitText) {
							case 'Work':
								if (this.formGroup.controls.txtRequisitionID.value.trim() != '') {
									if (!this.data.isViewing)
										this.UpdateActivities();
									this.hideEquipmentsVehicles = false;
									this.hideActivities = true;
									this.hideButtonNext = true;
									this.hideSendToApprove = false;
									//this.activeIndex = this.activeIndex + 1;
								} else {
									this.Alert(
										'Warning',
										'WARNINGS.Empty_fields',
									);
									this.activeIndex = this.activeIndex - 1;
									this.hideEquipmentsVehicles = true;
									this.hideActivities = false;
									this.hideButtonNext = false;
									this.hideSendToApprove = true;
								}
								break;
							default:
								if (!this.data.isViewing)
									this.UpdateActivities();
								this.hideEquipmentsVehicles = false;
								this.hideActivities = true;
                this.hideButtonNext = true;
                this.GetEquipments();
								if (!this.data.isViewing)
									this.hideSendToApprove = false;
								else this.hideButtonClose = false;
								break;
						}
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideEquipmentsVehicles = true;
						this.hideActivities = false;
					}
				}
				break;
			case 'Customers':
				
				if (this.activeIndex == 1) {
					if (
						this.formGroup.controls.txtvisitorname.valid &&
						this.formGroup.controls.txtvisitoremail.valid &&
						this.formGroup.controls.txtvisitorphone.valid
					) {
						if(this.formGroup.controls.pkvisit.value == 0){
							this.CreateCustomerVisit();
							this.hideGeneralInformation = true;
							this.hideSchedule = false;
						}else{
							if (!this.data.isViewing) this.AddVisitor();
							this.hideGeneralInformation = true;
							this.hideSchedule = false;
						}
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideGeneralInformation = false;
						this.hideSchedule = true;
					}
				}
				if (this.activeIndex == 2) {
					if (
						this.formGroup.controls.cbcalendar.value[0] != null &&
						this.formGroup.controls.cbcalendar.value[1] != null &&
						this.formGroup.controls.dtenddatevisit.valid &&
						this.formGroup.controls.dtstartdatevisit.valid
					) {
						if (!this.data.isViewing) this.UpdateScheduleVisit();
						this.hideSchedule = true;
						this.hideActivities = false;
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideSchedule = false;
						this.hideActivities = true;
					}
				}
				if (this.activeIndex == 3) {
					if (this.formGroup.controls.chknotfoundproject.value) {
						if (
							this.formGroup.controls.cbpkvisittype.valid &&
							this.formGroup.controls.cbpkarea.valid &&
							this.formGroup.controls.cbpkproject.valid &&
							this.formGroup.controls.cbpkactivity.valid &&
							this.formGroup.controls.cbpkactivity.value !=0 &&
							this.formGroup.controls.txtdescription.value.trim() != '' &&
							this.formGroup.controls.txtproject.value.trim() != ''
						) {
							if (!this.data.isViewing) this.UpdateActivities();
							this.hideActivities = true;
							this.hideEquipmentsVehicles = false;
						} else {
							this.Alert('Warning', 'WARNINGS.Empty_fields');
							this.activeIndex = this.activeIndex - 1;
							this.hideActivities = false;
							this.hideEquipmentsVehicles = true;
						}
					} else {
						if (
							this.formGroup.controls.cbpkvisittype.valid &&
							this.formGroup.controls.cbpkarea.valid &&
							this.formGroup.controls.cbpkproject.valid &&
							this.formGroup.controls.cbpkactivity.valid &&
							this.formGroup.controls.cbpkactivity.value !=0 &&
							this.formGroup.controls.txtdescription.value.trim() != ''
						) {
							if (!this.data.isViewing) this.UpdateActivities();
							this.hideActivities = true;
              this.hideEquipmentsVehicles = false;
              this.GetEquipments();
						} else {
							this.Alert('Warning', 'WARNINGS.Empty_fields');
							this.activeIndex = this.activeIndex - 1;
							this.hideActivities = false;
							this.hideEquipmentsVehicles = true;
						}
					}
				}
				if (this.activeIndex == 4) {
					this.hideButtonNext = true;
					if (!this.data.isViewing) this.hideSendToApprove = false;
					else this.hideButtonClose = false;
					this.hideEquipmentsVehicles = true;
          this.hideAdditionalInformation = false;
          this.Alert('Success', 'COMPLETE');
				}
				break;
			case 'Jabil visitors':
				if (this.activeIndex == 1) {
					if (
						this.formGroup.controls.cbpkoriginsite.valid &&
						this.formGroup.controls.cbpkoriginbuilding.valid &&
						this.formGroup.controls.cbpkbuildingtovisit.valid &&
						this.formGroup.controls.txtvisitorworkdayid.valid &&
						this.formGroup.controls.txtvisitorname.valid &&
						this.formGroup.controls.txtvisitoremail.valid &&
						this.formGroup.controls.txtsponsorname2.value != null
					) {
						if (!this.data.isViewing) this.AddVisitor();
						this.hideGeneralInformation = true;
						this.hideSchedule = false;
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideGeneralInformation = false;
						this.hideSchedule = true;
					}
				}
				if (this.activeIndex == 2) {
					if (
						this.formGroup.controls.cbcalendar.value[0] != null &&
						this.formGroup.controls.cbcalendar.value[1] != null &&
						this.formGroup.controls.dtenddatevisit.valid &&
						this.formGroup.controls.dtstartdatevisit.valid
					) {
						if (!this.data.isViewing) this.UpdateScheduleVisit();
						this.hideSchedule = true;
						this.hideActivities = false;
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideSchedule = false;
						this.hideActivities = true;
					}
				}
				if (this.activeIndex == 3) {
					if (
						this.formGroup.controls.cbpkvisittype.valid &&
						this.formGroup.controls.cbpkarea.valid &&
						this.formGroup.controls.cbpkproject.valid &&
						this.formGroup.controls.cbpkactivity.valid &&
						this.formGroup.controls.txtdescription.value.trim() != ''
					) {
						if (!this.data.isViewing) this.UpdateActivities();
						//this.activeIndex = this.activeIndex + 1;
						this.hideActivities = true;
            this.hideEquipmentsVehicles = false;
            this.GetEquipments();
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideActivities = false;
						this.hideEquipmentsVehicles = true;
					}
				}
				if (this.activeIndex == 4) {
					this.hideButtonNext = true;
					if (!this.data.isViewing) this.hideSendToApprove = false;
					else this.hideButtonClose = false;
					this.hideEquipmentsVehicles = true;
          this.hideAdditionalInformation = false;
          this.Alert('Success', 'COMPLETE');
				}
				break;
			case 'Recruitment':
				if (this.activeIndex == 1) {
					if (
						this.formGroup.controls.cbpkbuildingtovisit.value != '' &&
						this.formGroup.controls.txtsponsorname.value.trim() != '' &&
						this.formGroup.controls.txtvisitorname.value.trim() != '' &&
						this.formGroup.controls.txtvisitoremail.value.trim() != '' &&
						this.formGroup.controls.txtvisitorphone.valid
					) {
						if (!this.data.isViewing) {
							if (this.formGroup.controls.pkvisit.value == 0) {
								this.CreateVisit();
							} else {
								this.SetVisitor();
							}
						}
						this.hideGeneralInformation = true;
						this.hideSchedule = false;
					} 
					else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideGeneralInformation = false;
						this.hideSchedule = true;
					}
				}
				if (this.activeIndex == 2) {
					if (
						this.formGroup.controls.cbcalendar.value[0] != null &&
						this.formGroup.controls.cbcalendar.value[1] != null &&
						this.formGroup.controls.dtenddatevisit.valid &&
						this.formGroup.controls.dtstartdatevisit.valid
					) {
						if (!this.data.isViewing) {
							this.UpdateScheduleVisit();
							this.hideSendToApprove = false;
						} else {
							this.hideButtonClose = false;
						}
						this.hideSchedule = true;
						this.hideEquipmentsVehicles = false;
            this.hideButtonNext = true;
            this.GetEquipments();
					} else {
						this.Alert('Warning', 'WARNINGS.Empty_fields');
						this.activeIndex = this.activeIndex - 1;
						this.hideEquipmentsVehicles = true;
					}
				}
				break;
		}
		this.loading = false;
  }
  
	Previous() {
		this.activeIndex = this.activeIndex - 1;
		switch (this.visit_name) {
			case 'Suppliers':
				if (this.activeIndex == 0) {
					this.hideGeneralInformation = false;
					this.hideSchedule = true;
				}
				if (this.activeIndex == 1) {
					this.hideSchedule = false;
					this.hideActivities = true;
				}
				if (this.activeIndex == 2) {
					this.hideActivities = false;
					this.hideDocuments = true;
				}
				if (this.activeIndex == 3) {
					this.hideDocuments = false;
					this.hideActivities = true;
				}
				if (this.activeIndex < 4) {
					this.hideButtonNext = false;
					this.hideSendToApprove = true;
					this.hideEquipmentsVehicles = true;
					this.hideButtonClose = true;
				}
				break;
			case 'Not-Jabil visitors':
				if (this.activeIndex == 0) {
					this.hideSchedule = true;
					this.hideGeneralInformation = false;
				}
				if (this.activeIndex == 1) {
					this.hideSchedule = false;
					this.hideActivities = true;
				}
				if (this.activeIndex == 2) {
					this.hideActivities = false;
					this.hideSchedule = true;
				}
				if (this.activeIndex == 3) {
					this.hideActivities = true;
					this.hideEquipmentsVehicles = false;
				}
				if (this.activeIndex < 3) {
					this.hideButtonNext = false;
					this.hideSendToApprove = true;
					this.hideEquipmentsVehicles = true;
					this.hideButtonClose = true;
				}
				break;
			case 'Customers':
				
				if (this.activeIndex == 0) {
					this.hideGeneralInformation = false;
					this.hideSchedule = true;
				}
				if (this.activeIndex == 1) {
					this.hideSchedule = false;
					this.hideActivities = true;
				}
				if (this.activeIndex == 2) {
					this.hideActivities = false;
					this.hideEquipmentsVehicles = true;
				}
				if (this.activeIndex == 3) {
					this.hideEquipmentsVehicles = false;
					this.hideAdditionalInformation = true;
				}
				if (this.activeIndex == 4) {
					this.hideAdditionalInformation = false;
					this.hideEquipmentsVehicles = true;
				}
				if (this.activeIndex < 5) {
					this.hideButtonNext = false;
					this.hideSendToApprove = true;
					this.hideButtonClose = true;
				}
				break;
			case 'Jabil visitors':
				if (this.activeIndex == 0) {
					this.hideGeneralInformation = false;
					this.hideSchedule = true;
				}
				if (this.activeIndex == 1) {
					this.hideSchedule = false;
					this.hideActivities = true;
				}
				if (this.activeIndex == 2) {
					this.hideActivities = false;
					this.hideEquipmentsVehicles = true;
				}
				if (this.activeIndex == 3) {
					this.hideEquipmentsVehicles = false;
					this.hideAdditionalInformation = true;
				}
				if (this.activeIndex == 4) {
					this.hideAdditionalInformation = false;
					this.hideEquipmentsVehicles = true;
				}
				if (this.activeIndex < 5) {
					this.hideButtonNext = false;
					this.hideSendToApprove = true;
					this.hideButtonClose = true;
				}
				break;
			case 'Jabil visitors':
				if (this.activeIndex == 0) {
					this.hideGeneralInformation = false;
					this.hideSchedule = true;
				}
				if (this.activeIndex == 1) {
					this.hideSchedule = false;
					this.hideEquipmentsVehicles = true;
				}
				if (this.activeIndex == 2) {
					this.hideEquipmentsVehicles = false;
					this.hideSchedule = true;
				}
				if (this.activeIndex < 2) {
					this.hideButtonNext = false;
					this.hideSendToApprove = true;
					this.hideButtonClose = true;
				}
				break;
			case 'Recruitment':
				if (this.activeIndex == 0) {
					this.hideGeneralInformation = false;
					this.hideSchedule = true;
				}
				if (this.activeIndex == 1) {
					this.hideSchedule = false;
					this.hideEquipmentsVehicles = true;
				}
				if (this.activeIndex == 2) {
					this.hideEquipmentsVehicles = false;
					this.hideSchedule = true;
				}
				if (this.activeIndex < 2) {
					this.hideButtonNext = false;
					this.hideSendToApprove = true;
					this.hideButtonClose = true;
				}
				break;
		}
  }
  
  SendToApprove() {
    this.loading = true;
		switch (this.visit_name) {
			case 'Customers':
				debugger
				this.visitsService.SetVisitor(this.formGroup.value).subscribe(
				(result: TransactionResult<number>) => {
					if (result.success && result.data != 0) {
						this.visitsService.SendToApprove(this.formGroup.value).subscribe(
						(result: TransactionResult<boolean>) => {
							if (result.success) {
								this.Alert('Success', 'COMPLETE');
								this.Close();
              } else {
                this.loading = false;
                this.Alert("Error", "MYREQUEST.Failed_to_send_for_approval");
              }
						},
						(error: any) => {
							this.ErrorAlert(error);
							this.loading = false;
						});
          } else {
            this.loading = false;
            this.Alert("Error", "MYREQUEST.Save_visitor_information_fail");
          }
        },
        (error: any) => {
          this.ErrorAlert(error);
          this.loading = false;
        });

				break;
			case 'Jabil visitors':
				this.visitsService.SetVisitor(this.formGroup.value).subscribe(
				(result: TransactionResult<number>) => {
					if (result.success && result.data != 0) {
						this.visitsService.SendToApprove(this.formGroup.value).subscribe(
						(result: TransactionResult<boolean>) => {
							if (result.success) {
								this.Alert('Success', 'COMPLETE');
								this.Close();
              } else {
                this.loading = false;
                this.Alert("Error", "MYREQUEST.Failed_to_send_for_approval");
              }
						},
						(error: any) => {
							this.ErrorAlert(error);
							this.loading = false;
						});
          } else {
            this.loading = false;
            this.Alert("Error", "MYREQUEST.Save_visitor_information_fail"); 
          }
				});
				break;
			default:
				this.visitsService.SendToApprove(this.formGroup.value).subscribe(
					(result: TransactionResult<boolean>) => {
						if (result.success) {
							this.Alert('Success', 'COMPLETE');
							this.Close();
            } else {
              this.loading = false;
              this.Alert("Error", "MYREQUEST.Failed_to_send_for_approval");
            }
					},
					(error: any) => {
						this.ErrorAlert(error);
						this.loading = false;
					});
				break;
		}
  }
  
	SetItemsFlow() {
		// This is necessary yo hide the components not required in request when is editting
		switch (this.visit_name) {
			case 'Suppliers': {
				this.items = [
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.General_information',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Schedule',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Activities',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Documents',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Equipments_vehicules',
						),
					},
				];
				this.hideButtonSaveVisitor = false;
				this.hideCompanySupplier = false;
				this.hideCriticalWork = false;
				this.hideForeignVisit = false;
				this.hideIdentificationType = false;
				this.hideVisitorPosition = false;
				this.hideVisitorID = false;
				this.hideRequiredIDPO = true;
				this.hideSendToApprove = true;
				this.hideStartToWork = false;
				this.hideSubtypesvisits = true;
				this.hideSupplierIncomeType = false;
				this.hideTemporalBadge = false;
				this.hideUploadVisitorPhoto = false;
				this.hideVisitorsCatalog = false;
				this.hideVisitorsOwner = false;
				this.hideOriginBuilding = true;
				this.hideOriginSite = true;
				this.hideVisitorWorkdayID = true;
				this.hideVisitorPhone = false;
				this.hideVisitorSponsor = true;
				this.hideVisitorBadge = true;

				if(!this.isFieldReadOnly){
					this.isReadOnlyWorkdayID = false;
					this.isReadOnlyVisitorName = false;
					this.isReadOnlyVisitorEmail = false;
				}
				else{
					this.SetReadOnlyToFields();
				}

				this.hideNotFoundProject = true;
				this.GetCompanySuppliers();
				break;
			}
			case 'Not-Jabil visitors': {
				this.items = [
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.General_information',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Schedule',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Activities',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Equipments_vehicules',
						),
					},
				];
				this.hideButtonSaveVisitor = true;
				this.hideCompanySupplier = true;
				this.hideCriticalWork = true;
				this.hideForeignVisit = true;
				this.hideIdentificationType = false;
				this.hideVisitorPosition = false;
				this.hideVisitorID = false;
				this.hideSendToApprove = true;
				this.hideStartToWork = true;
				this.hideSubtypesvisits = false;
				this.hideRequiredIDPO = false;
				this.hideSupplierIncomeType = true;
				this.hideTemporalBadge = true;
				this.hideUploadVisitorPhoto = true;
				this.hideVisitorsCatalog = true;
				this.hideVisitorsOwner = true;
				this.hideOriginBuilding = true;
				this.hideOriginSite = true;
				this.hideVisitorWorkdayID = true;
				this.hideVisitorPhone = false;
				this.hideVisitorSponsor = true;
				this.hideVisitorBadge = true;

				if(!this.isFieldReadOnly){
					this.isReadOnlyWorkdayID = false;
					this.isReadOnlyVisitorName = false;
					this.isReadOnlyVisitorEmail = false;
				}
				else{
					this.SetReadOnlyToFields();
				}

				this.hideNotFoundProject = true;
				this.GetSubtypesVisits();
				break;
			}
			case 'Customers': {
				
				this.items = [
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.General_information',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Schedule',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Activities',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Equipments_vehicules',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Additional_information',
						),
					},
				];
				this.hideButtonSaveVisitor = true;
				this.hideCompanySupplier = true;
				this.hideCriticalWork = true;
				this.hideForeignVisit = true;
				this.hideIdentificationType = true;
				this.hideVisitorPosition = true;
				this.hideVisitorID = true;
				this.hideSendToApprove = true;
				this.hideStartToWork = true;
				this.hideSubtypesvisits = true;
				this.hideRequiredIDPO = true;
				this.hideSupplierIncomeType = true;
				this.hideTemporalBadge = true;
				this.hideUploadVisitorPhoto = true;
				this.hideVisitorsCatalog = true;
				this.hideVisitorsOwner = true;
				this.hideOriginBuilding = true;
				this.hideOriginSite = true;
				this.hideVisitorWorkdayID = true;
				this.hideVisitorPhone = false;
				this.hideVisitorSponsor = true;
				this.hideVisitorBadge = true;

				if(!this.isFieldReadOnly){
					this.isReadOnlyWorkdayID = false;
					this.isReadOnlyVisitorName = false;
					this.isReadOnlyVisitorEmail = false;
				}
				else{
					this.SetReadOnlyToFields();
				}

        		this.hideNotFoundProject = true;
        
				break;
			}
			case 'Jabil visitors': {
				this.items = [
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.General_information',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Schedule',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Activities',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Equipments_vehicules',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Additional_information',
						),
					},
				];
				this.hideButtonSaveVisitor = true;
				this.hideCompanySupplier = true;
				this.hideCriticalWork = true;
				this.hideForeignVisit = true;
				this.hideIdentificationType = true;
				this.hideVisitorPosition = true;
				this.hideVisitorID = true;
				this.hideSendToApprove = true;
				this.hideStartToWork = true;
				this.hideSubtypesvisits = true;
				this.hideRequiredIDPO = true;
				this.hideSupplierIncomeType = true;
				this.hideTemporalBadge = false;
				this.hideUploadVisitorPhoto = true;
				this.hideVisitorsCatalog = true;
				this.hideVisitorsOwner = true;
				this.hideOriginBuilding = false;
				this.hideOriginSite = false;
				this.hideVisitorWorkdayID = false;
				this.hideVisitorPhone = true;
				this.hideVisitorSponsor = false;
				this.hideVisitorBadge = false;

				this.isReadOnlyWorkdayID = true;
				this.isReadOnlyVisitorName = true;
				this.isReadOnlyVisitorEmail = true;

				if(this.isFieldReadOnly){
					this.SetReadOnlyToFields();
				}
				

				this.hideNotFoundProject = true;
				this.GetAvailableSites();
				break;
			}
			case 'Recruitment': {
				this.items = [
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.General_information',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Schedule',
						),
					},
					{
						label: this.translate.TranslateKey(
							'MYREQUEST.Equipments_vehicules',
						),
					},
				];
				this.hideButtonNext = false;
				this.hideButtonSaveVisitor = true;
				this.hideCompanySupplier = true;
				this.hideCriticalWork = true;
				this.hideForeignVisit = true;
				this.hideIdentificationType = true;
				this.hideVisitorPosition = true;
				this.hideVisitorID = true;
				this.hideSendToApprove = true;
				this.hideStartToWork = true;
				this.hideSubtypesvisits = true;
				this.hideRequiredIDPO = true;
				this.hideSupplierIncomeType = true;
				this.hideTemporalBadge = true;
				this.hideUploadVisitorPhoto = true;
				this.hideVisitorsCatalog = true;
				this.hideVisitorsOwner = true;
				this.hideOriginBuilding = true;
				this.hideOriginSite = true;
				this.hideVisitorWorkdayID = true;
				this.hideVisitorPhone = false;
				this.hideVisitorSponsor = true;
				this.hideVisitorBadge = true;

				this.isReadOnlyWorkdayID = true;
				if(!this.isFieldReadOnly){
					this.isReadOnlyVisitorName = false;
					this.isReadOnlyVisitorEmail = false;
				}
				else{
					this.SetReadOnlyToFields();
				}
				

				this.hideNotFoundProject = true;
				break;
			}
		}
		this.GetBuildingsBySite();
	}

	SetReadOnlyToFields(){
		this.isReadOnlyWorkdayID = true;
		this.isReadOnlyVisitorName = true;
		this.isReadOnlyVisitorEmail = true;
		this.isReadOnly = true;
		this.isReadOnlyID = true;
		this.isReadOnlyRequiredID = true;
		this.readOnlyProject = true;
		this.maxDate.setDate(this.minDate.getDate());
		this.maxDate.setMonth(this.minDate.getMonth() - 1);
	}

	SetSponsor() {
		this.visitsService
			.SetSponsor(this.formGroup.value)
			.subscribe((result: TransactionResult<boolean>) => {
				if (result.success) {
					this.formGroup.controls.txtsponsorname2.setValue(
						'(' +
							this.formGroup.controls.sponsorworkdayid.value +
							') - ' +
							this.formGroup.controls.sponsorname.value,
					);
					//this.Alert('Success', 'COMPLETE');
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Save_sponsor_information_fail");
        }
			},
      (error: any) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
  }
  
	SetVisitor() {
		this.visitsService.SetVisitor(this.formGroup.value).subscribe(
		(result: TransactionResult<number>) => {
			if (result.success && result.data != 0) {
				this.formGroup.controls.pkvisitor.setValue(result.data);
				//this.Alert('Success', 'COMPLETE');
				this.AddVisitor();
				this.loading = false;
      } else {
        this.loading = false;
        this.Alert("Error", "MYREQUEST.Save_visitor_information_fail"); 
      }
		},
    (error: any) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }
  
	ShowDialog(display: boolean) {
		this.display = display;
		if (!display) {
			this.selectedVisitType = true;
			this.loading = true;
			this.SetItemsFlow();
		}
  }
  
	ShowMessage(item: number) {
		this.visitsTypesService.GetVisitsTypes().subscribe(
		(result: TransactionResult<IVisitsTypes[]>) => {
			if (result.success) {
				this.listVisitsTypes = result.data;
				this.visit_name = this.listVisitsTypes.filter(
					(element) => element.pkvisittype == item,
				)[0].visittype;
				this.data.fkvisittype = this.listVisitsTypes.filter(
					(element) => element.pkvisittype == item,
				)[0].pkvisittype;
				if (this.formGroup.controls.cbpkvisittype.value != 0 && (this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() == 'draft'.toLocaleLowerCase() || 
				this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() == '')) {
					if (this.visit_name != 'Suppliers') {
						this.message = this.translate.TranslateKey(
							'MYREQUEST.message_general_visit',
						);
						this.ShowDialog(true);
					} else {
						this.display_foreign_visit = true;
					}
				}
				if(this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() != 'draft'.toLocaleLowerCase() && 
				this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() != ''){
					this.isFieldReadOnly = true;
					this.selectedVisitType = true;
					this.loading = true;
					this.SetItemsFlow();
				}
      } else {
        this.loading = false;
        this.Alert("Error", "MYREQUEST.Error_retrieving_list_of_visit_types"); 
      }
		},
		(error: any) => {
			this.ErrorAlert(error);
		});
  }
  
	ShowMessageForeignVisit(isForeignVisit: boolean) {
		this.message = this.translate.TranslateKey(
			'MYREQUEST.message_supplier_visit',
		);
		if (isForeignVisit) {
			this.formGroup.controls.chkvisitorforeignvisit.setValue(true);
		} else {
			this.formGroup.controls.chkvisitorforeignvisit.setValue(false);
		}
		this.display_foreign_visit = false;
		this.ShowDialog(true);
  }
  
	UpdateActivities() {
		this.loading = true;
		this.visitsService
			.UpdateActivities(this.formGroup.value)
			.subscribe((result: TransactionResult<boolean>) => {
				if (result.success) {
					this.disable = false;
					this.Alert('Success', 'COMPLETE');
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Error_updating_visit_activity_information"); 
        }
      },
      (error: any) => {
        this.ErrorAlert(error);
      });
  }
  
	UpdateGeneralInformation() {
		this.loading = true;
		this.visitsService
			.UpdateGeneralInformation(this.formGroup.value)
			.subscribe((result: TransactionResult<boolean>) => {
        if (result.success) {
          if(this.visit_name != "Not-Jabil visitors")
					  this.Alert('Success', 'COMPLETE');
					this.disable = false;
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Error_updating_visit_general_information"); 
        }
			},
      (error: any) => {
        this.ErrorAlert(error);
      });
  }
  
	UpdateScheduleVisit() {
		this.loading = true;
		this.visitsService
			.UpdateScheduleVisit(this.formGroup.value)
			.subscribe((result: TransactionResult<boolean>) => {
        if (result.success) {
          /* if (this.visit_name == "Suppliers") {
            this.GetDocumentsTypes();
          } */
          this.Alert('Success', 'COMPLETE');
					this.disable = false;
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Error_updating_visit_schedule_information"); 
        }
			},
      (error: any) => {
        this.ErrorAlert(error);
      });
  }
  
	UploadDocument(fk_document_type: number) {
		this.dataDocumentToSend.fk_document_type = fk_document_type;
		this.dataDocumentToSend.fk_visit = this.formGroup.controls.pkvisit.value;
		const dialogRef = this.dialog.open(UploadDocumentComponent, {
			data: this.dataDocumentToSend,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result == true) {
        this.listDocumentsTypes.forEach((element) => {
					if (element.pkdocumenttype == fk_document_type) {
						element.loaded = true;
					}
				});
			}
		});
  }
  
	UploadID() {
		this.loading = false;
		this.isReadOnlyID = false;
		const dialogRef = this.dialog.open(UploadImageComponent, {
			data: this.formGroup.value,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if(result.pkvisit != 0 && result.pkvisitor != 0){
				this.loading = false;
				this.formGroup.controls.pkvisit.setValue(result.pkvisit);
				this.formGroup.controls.pkvisitor.setValue(result.pkvisitor);
				this.formGroup.controls.imgVisitorID.setValue(true);
				this.formGroup.controls.isnewvisitor.setValue(false);
				if (
					this.visit_name == 'Not-Jabil visitors' ||
					this.visit_name == 'Jabil visitors'
				) {
					this.hideButtonNext = false;
					if (this.data.recordstatus == '' || this.data.recordstatus == 'Draft' || this.data.recordstatus == undefined) {
						this.AddVisitor();
					}
				}
			}
			
		});
  }

  	ValidateVisitor() {
		this.visitsService.SetVisitor(this.formGroup.value).subscribe(
			(result: TransactionResult<number>) => {
				if (result.success && result.data != 0) {
					this.formGroup.controls.pkvisitor.setValue(result.data);
					const dialogRef = this.dialog.open(UploadImagePhotoComponent, {
						data: this.formGroup.value,
					});
					dialogRef.afterClosed().subscribe((result) => {
						if (result) {
							this.formGroup.controls.imgVisitorPhoto.setValue(true);
							this.enableBtnAddVisitor = true;
							if(this.formGroup.controls.pkvisit.value != 0 && this.formGroup.controls.pkvisitor.value != 0){
								this.loading = false;
								//this.formGroup.controls.pkvisit.setValue(result.pkvisit);
								//this.formGroup.controls.pkvisitor.setValue(result.pkvisitor);
								this.formGroup.controls.imgVisitorID.setValue(true);
								this.formGroup.controls.isnewvisitor.setValue(false);
								
								if (
									this.visit_name == 'Customers' 
								) {
									this.hideButtonNext = false;
									if (this.data.recordstatus == '' || this.data.recordstatus == 'Draft' || this.data.recordstatus == undefined) {
										this.AddVisitor();
									}
								}
							}
						}
						this.loading = false;
					});
		} else {
		this.loading = false;
		this.Alert("Error", "MYREQUEST.Save_visitor_information_fail");
		}
			},
			(error: any) => {
				this.ErrorAlert(error);
				this.loading = false;
			},
		);
	}
  
	UploadVisitorPhoto() {
		this.loading = true;
		if (this.formGroup.controls.pkvisit.value == 0) {
			this.visitsService.CreateVisit(this.formGroup.value).subscribe(
				(result: TransactionResult<number>) => {
					if (result.success) {
						this.formGroup.controls.pkvisit.setValue(result.data);
						this.data.pkvisit = result.data;
						this.ValidateVisitor();
          } else {
            this.loading = false;
            this.Alert("Error", "MYREQUEST.Error_creating_new_visit");
          }
				},
				(error: any) => {
					this.ErrorAlert(error);
					this.loading = false;
				},
			);
    } else {
      this.ValidateVisitor()
		}
	
		
  }
  
	ValidateDates(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value;
			if (!value) {
				return null;
			}
			const dateValid = true;
			return !dateValid ? { validDate: true } : null;
		};
  }

  ValidateDocumentsConditions(document: any) {
    let doc = {
      'block_button': document.available == false,
      'btn-secondary': document.available == false || (document.available == true && document.loaded == false),
      'btn-primary': document.available == true && document.loaded == true
    };

    return doc;
  }
  
	ValidateDocumentsLoadWithActivitySelected() {
		let activity = this.listActivities.filter(
			(element) =>
				element.pkactivity ==
				this.formGroup.controls.cbpkactivity.value,
		);
		this.listDocumentsTypes.forEach((element) => {
			if (element.documenttype == 'DC3') {
        element.available = activity[0].dc3;
        if (activity[0].dc3 == false) {
          element.required_foreign_visit = activity[0].dc3;
        }
			}
			if (element.documenttype == 'Safety data sheet') {
        element.available = activity[0].chemicalsubstance;
        if (activity[0].chemicalsubstance == false) {
          element.required_foreign_visit = activity[0].chemicalsubstance;
        }
			}
    });
    this.GetDocumentsLoadedByVisit();
  }
  
	ValidateSubtypeVisitSelected(subtypeVisit: number): void {
		if(this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() == 'draft'.toLocaleLowerCase() || 
      this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() == '' ||
      this.formGroup.controls.txtRecordStatus.value.toLocaleLowerCase().trim() == 'none') {
			this.loading = true;
			if (this.visit_name == 'Not-Jabil visitors') {
				if(this.listSubtypesVisits.length == 0){
					this.subtypesVisitsService.GetSubtypesVisits().subscribe(
					(result: TransactionResult<ISubtypesVisits[]>) => {
						if (result.success) {
							this.listSubtypesVisits = result.data;
							this.subtypeVisitText = this.listSubtypesVisits.filter(
								element => element.pk_subtype_visit == subtypeVisit,
							)[0].subtype_visit;
							if (this.subtypeVisitText == 'Work') {
								this.isReadOnlyRequiredID = false;
							} else {
								this.isReadOnlyRequiredID = true;
								this.formGroup.controls.txtRequisitionID.setValue('');
							}
        				}
						else{
          					this.loading = false;
          					this.Alert('Error', 'MYREQUEST.Error_retrieving_list_of_subtypes_visits');
        				}
					},
      				(error: any) => {
        				this.ErrorAlert(error);
        				this.loading = false;
      				});
				}
				else{
					this.subtypeVisitText = this.listSubtypesVisits.filter(
						(element) => element.pk_subtype_visit == subtypeVisit,
					)[0].subtype_visit;
					if (this.subtypeVisitText == 'Work') {
						this.isReadOnlyRequiredID = false;
					} else {
						this.isReadOnlyRequiredID = true;
						this.formGroup.controls.txtRequisitionID.setValue('');
					}
				}
			}
			this.loading = false;
		}
  	}
}
